/**
 * Determines the warning properties for a photo preview based on its badge type.
 *
 * @param {Object} photo - The specific photo instance being rendered.
 * @param {Map<string, string|null>} badgeTypeMap - A map of size keys to badge types for the photo's root image.
 * @param {Object} recommendedPrintSize - The recommended print size object for the photo's root image.
 * @returns {{showPreviewWarning: boolean, recommendedPrintSizeTextForPreview: string|undefined}}
 */
export default function getPhotoPreviewWarningProps(
  photo,
  badgeTypeMap,
  recommendedPrintSize,
) {
  let showPreviewWarning = false;
  let recommendedPrintSizeTextForPreview;

  if (photo && badgeTypeMap) {
    const sizeKey = photo.size?.key;
    const photoBadgeType = badgeTypeMap.get(sizeKey);

    if (
      photoBadgeType === 'raw_photo_low_res' ||
      photoBadgeType === 'cropped_too_small'
    ) {
      showPreviewWarning = true;
    }
  }

  if (recommendedPrintSize && badgeTypeMap) {
    const recommendedBadgeType = badgeTypeMap.get(recommendedPrintSize.key);

    // Do not show the "recommended" text if that size itself has a crop warning
    if (recommendedBadgeType !== 'cropped_too_small') {
      recommendedPrintSizeTextForPreview = recommendedPrintSize.title;
    }
  }

  return { showPreviewWarning, recommendedPrintSizeTextForPreview };
}
